var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpenseEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 372,
    height: 387,
    viewBox: "0 0 372 387",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.976 386.011C272.963 386.011 345.918 313.056 345.918 222.747C345.918 132.438 272.963 59.484 182.976 59.484C92.988 59.484 20.0337 132.438 20.0337 222.747C20.0337 313.056 92.988 386.011 182.976 386.011Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1001 117.012H294.818C304.139 117.012 311.209 124.082 311.209 133.403V280.275C311.209 289.595 304.139 296.666 294.818 296.666H63.1001C53.7799 296.666 46.7095 289.595 46.7095 280.275V133.403C46.7095 124.082 54.4227 117.012 63.1001 117.012Z",
    fill: "#E4DAFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M315.709 211.177V283.489C315.709 292.809 308.317 300.522 298.675 300.522H60.5292C51.2091 300.522 43.4958 292.809 43.4958 283.489V205.071",
    fill: "#E4DAFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M315.709 211.177V283.489C315.709 292.809 308.317 300.522 298.675 300.522H60.5292C51.2091 300.522 43.4958 292.809 43.4958 283.489V205.071",
    stroke: "#1676EE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M295.462 170.683H220.258C212.866 170.683 205.795 173.255 200.332 177.754L180.727 193.823C175.264 198.323 168.193 200.894 160.801 200.894H75.9559C67.2785 200.894 60.208 207.964 60.208 216.641C60.208 217.284 60.208 218.248 60.5294 218.891L76.2772 301.808C77.5628 309.522 83.9905 315.307 92.0251 315.307H273.607C281.321 315.307 288.07 309.843 289.355 302.13L311.209 188.681C312.816 180.004 307.031 172.29 298.354 170.683C297.068 170.683 296.104 170.683 295.462 170.683Z",
    fill: "#E4DAFC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_33_30997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.206 148.506H231.505C221.864 148.506 212.865 151.72 205.473 157.827L179.762 178.717C172.692 184.501 163.372 188.037 153.73 188.037H43.1737C31.9253 188.037 22.9265 197.357 22.9265 208.284C22.9265 209.248 22.9265 210.212 23.2479 211.176L43.4951 319.483C45.102 329.767 53.7794 337.159 63.7424 337.159H300.281C310.566 337.159 318.922 330.089 320.529 319.804L349.132 171.646C351.06 160.398 343.668 150.435 332.42 148.185C331.456 148.506 330.17 148.506 329.206 148.506Z",
    fill: "url(#paint0_linear_33_30997)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.233 260.673C146.018 260.673 150.839 255.853 150.839 250.068C150.839 244.283 146.018 239.462 140.233 239.462C134.448 239.462 129.627 244.283 129.627 250.068C129.627 255.853 134.448 260.673 140.233 260.673Z",
    fill: "#15112D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M222.828 260.348C228.613 260.348 233.434 255.527 233.434 249.742C233.434 243.958 228.613 239.137 222.828 239.137C217.043 239.137 212.222 243.958 212.222 249.742C212.222 255.849 217.043 260.348 222.828 260.348Z",
    fill: "#15112D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M344.955 329.768C343.669 335.231 341.741 341.016 339.491 345.837C333.385 357.728 323.743 367.049 311.852 373.155C299.639 379.261 285.177 381.832 270.715 378.618C236.648 371.548 214.794 338.124 221.864 304.057C228.935 269.99 262.037 247.815 296.104 255.207C308.317 257.778 318.923 263.884 327.921 272.24C343.026 287.345 349.454 309.199 344.955 329.768Z",
    fill: "#7647EE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M303.495 311.451H289.032V296.989C289.032 294.097 286.783 291.525 283.569 291.525C280.676 291.525 278.105 293.775 278.105 296.989V311.451H263.643C260.751 311.451 258.179 313.701 258.179 316.915C258.179 320.129 260.429 322.378 263.643 322.378H278.105V336.841C278.105 339.733 280.355 342.304 283.569 342.304C286.461 342.304 289.032 340.055 289.032 336.841V322.378H303.495C306.387 322.378 308.958 320.129 308.958 316.915C308.958 313.701 306.387 311.451 303.495 311.451Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M168.513 184.502C156.943 162.005 154.372 135.009 162.085 110.584C169.477 86.1587 187.153 65.2687 209.008 53.3775C215.757 49.8423 223.47 46.9498 231.183 46.6284C238.896 46.307 247.252 48.8781 252.395 55.3058C257.537 61.0907 258.501 70.7322 254.323 77.1599C249.824 83.2662 240.825 85.8373 233.433 83.909C221.542 81.6593 211.9 72.3392 209.008 61.0907C206.115 49.8423 209.972 36.6655 218.971 29.2736C224.756 24.1315 232.79 21.239 240.182 18.9893C276.177 8.38365 315.386 7.09811 352.024 15.1327",
    stroke: "#C9D4E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M191.653 271.919H171.727V276.74H191.653V271.919Z",
    fill: "#15112D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M371.307 6.77753C370.986 11.5983 370.664 16.0977 367.129 17.0618C363.594 18.026 361.987 14.8121 359.737 10.3128C357.488 6.13476 358.773 1.63538 362.63 0.671224C366.165 -0.292929 371.95 0.992608 371.307 6.77753Z",
    fill: "#DAE2EB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M367.452 29.9164C368.416 24.1314 369.38 20.9176 366.166 19.3107C362.631 17.7037 360.381 20.5962 356.524 24.4528C353.311 27.9881 355.239 33.1302 358.453 34.7371C362.309 36.6654 366.487 34.7371 367.452 29.9164Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M371.951 19.311C371.629 21.5607 370.022 23.1676 367.773 23.489C366.809 23.489 365.844 23.489 364.559 23.489C360.06 22.8462 356.524 19.9538 356.846 17.0613C357.167 14.1688 361.345 12.5619 366.487 13.2047C367.451 13.2047 368.416 13.5261 369.058 13.8474C370.987 14.4902 372.272 16.7399 371.951 19.311C371.951 19.311 371.951 18.9896 371.951 19.311Z",
    fill: "#989FB0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2856 109.619C13.2856 104.156 13.2856 98.6922 17.1423 97.0853C21.3203 95.4784 23.57 99.335 26.7838 104.799C29.6763 109.619 28.3907 114.761 24.2127 116.368C20.6775 117.975 13.2856 117.011 13.2856 109.619Z",
    fill: "#DAE2EB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5352 82.6222C14.8924 89.3713 13.9282 93.2279 18.1062 94.8349C22.2842 96.4418 24.5339 92.9066 28.7119 87.7644C31.9258 83.265 29.6761 77.4801 25.4981 75.8732C21.3201 74.2662 16.1779 77.1587 15.5352 82.6222Z",
    fill: "#DAE2EB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 95.4813C11.9998 92.9102 13.9281 90.9819 16.1778 90.6605C17.1419 90.3392 18.4274 90.3392 19.713 90.6605C24.8551 90.9819 29.3545 93.8744 29.0331 97.0882C28.7117 100.302 24.5337 102.552 19.0702 101.909C18.1061 101.909 17.1419 101.588 16.1778 101.266C13.6067 100.945 11.9998 98.3738 11.9998 95.4813Z",
    fill: "#989FB0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.853 96.4424C67.5984 96.4424 129.947 116.047 130.911 188.037",
    stroke: "#C9D4E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_33_30997",
    x: 0.926514,
    y: 137.185,
    width: 370.511,
    height: 232.974,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33_30997"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33_30997",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_30997",
    x1: 186.076,
    y1: 143.814,
    x2: 186.076,
    y2: 339.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenseEmptyState);
export default __webpack_public_path__ + "static/media/expenseEmptyState.37007e987591d4b9add2ebb296e21ed0.svg";
export { ForwardRef as ReactComponent };